import { motion } from 'motion/react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useGetParams } from '../../hooks/useGetParams';

import { Message } from '../Message/Message';
import { Title } from '../Title/Title';
import { Confetti } from '../Confetti/Confetti';

import styles from './MessagesList.module.css';
import logo from '../../assets/images/logo.png';

export const MessagesList = ({ messages, winId, speed, isStateWin }) => {
  const { authorFontSize } = useGetParams();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles.wrapper}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={styles.logoBlock}
      >
        <img src={logo} alt="" />
      </motion.div>

      {isStateWin && <Title line={'Победитель!'} startDelay={0.6} />}

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages?.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={speed}
                classNames="position"
              >
                <Message
                  winId={winId}
                  key={item.id}
                  message={item.message}
                  authorFontSize={authorFontSize}
                  isStateWin={isStateWin}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      </div>

      {isStateWin && <Confetti startDelay={1500} />}
    </motion.div>
  );
};
